/**
 * The default campaign angle: what FTC wants a cold outreach email to convey.
 *
 * Canonical copy. The composer pre-fills it, and the MCP voice-rules tool
 * returns it so an agent drafts from the same brief rather than from memory
 * of a past session.
 *
 * Content rules baked into this text, each one hard-won:
 * - Oklahoma City only. Never claim Dallas.
 * - Representation plus a competitive process is the message, not valuation.
 * - Present tense about which side we work ("we represent business owners"),
 *   never absolutes like "exclusively" or "never work with buyers".
 * - The ask is a meeting. Never a free market value analysis: FTC sells those.
 *
 * This text is guidance an agent reads alongside the rules, so it must itself
 * obey them. It said "Happy to talk informally about how a process works"
 * until 2026-08-06, which by then was a banned closer, meaning the brief was
 * teaching a phrase the linter rejects. `outreachAngle.test.ts` now lints it.
 */
export const DEFAULT_ANGLE =
  "First Turn Capital is an M&A advisory firm in Oklahoma City. We represent business owners when they sell their company. Buyers approach owners directly one at a time and a single buyer with no competition sets his own price. We run a competitive process instead: we take the company to many buyers, get them bidding against each other, and put several offers in front of the owner to choose from, then fight for the highest value and get the deal closed. We are running two sale processes for Texas services companies right now. The ask is a meeting: getting to know the owner and hearing about what they built. Phone: (405) 602-2146.";
